exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".uniformity-container[data-v-cd3a9c40]{padding-left:calc(48px + 25%)!important}", "", {"version":3,"sources":["/home/ponce-dev-production/report/src/components/Audits/Uniformity.vue"],"names":[],"mappings":"AACA,uCACE,uCAA0C,CAC3C","file":"Uniformity.vue","sourcesContent":["\n.uniformity-container[data-v-cd3a9c40] {\n  padding-left: calc(48px + 25%) !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cd3a9c40","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Audits/Uniformity.vue
// module id = 1533
// module chunks = 0